/**
 * StatusCodes
 */
export var StatusCodes;
(function (StatusCodes) {
    StatusCodes["OK"] = "200";
    StatusCodes["UNAUTHORIZED"] = "401";
    StatusCodes["FORBIDDEN"] = "403";
    StatusCodes["INTERNAL_ERROR"] = "500";
    StatusCodes["BAD_REQUEST"] = "400";
    StatusCodes["PAYMENT_REQUIRED"] = "402";
    StatusCodes["NOT_FOUND"] = "404";
    StatusCodes["METHOD_NOT_ALLOWED"] = "405";
    StatusCodes["NOT_ACCEPTABLE"] = "406";
    StatusCodes["REQUEST_TIMEOUT"] = "408";
    StatusCodes["CONFLICT"] = "409";
    StatusCodes["GONE"] = "410";
})(StatusCodes || (StatusCodes = {}));
